var _defs, _path, _g, _rect, _rect2, _circle, _polyline, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvertismentGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.57 139.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.81,82.1c.05,1.81-1.38,3.31-3.19,3.37-.57.02-1.13.04-1.7.05-.11,0-.22,0-.34.01-3.24.11-6.38.2-9.46.14-1.9-.04-3.78-.13-5.66-.33-2.15-.23-4.17-.92-5.98-1.99-4.98-2.93-7.45-8.24-8.51-14.39-.19-1.09-.2-1.51-.24-2.17-.37-6.92,6.64-15.3,14.83-16.04,2.45-.22,4.89-.32,7.35-.42,2.42-.1,4.87-.17,7.38-.24.45-.01.9-.03,1.36-.04,1.82-.06,3.34,1.38,3.39,3.2v.57s.11,3.58.11,3.58l.13,4.86.08,2.98.13,4.86.09,3.58.13,4.86.09,3.58h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.6,76.02l-.89,3.1c-.05.16-.11.32-.19.47-.55.99-1.09,1.99-1.63,2.99-1.54,2.82-3.12,5.72-4.74,8.51l-.03.05c-.44.75-1.15.95-1.53,1.01-.7.1-1.38-.12-1.89-.6l-.33-.31c-.83-.79-.93-2.09-.25-3.03,10.21-13.99,9.71-32.2-1.25-45.33-.72-.86-.68-2.15.11-2.99l.31-.32c.45-.48,1.07-.73,1.74-.7.19.01.37.04.54.09.45.13.85.39,1.14.77,1.44,1.81,2.84,3.61,3.99,5.53,5.28,8.79,7,18.35,5.12,28.43-.11.59-.12,1.17-.14,1.67v.11c0,.19-.03.38-.09.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.03,96.26c-.21.18-.77.55-1.42.22l-1.77-.86c-1.78-.86-3.57-1.74-5.4-2.59-1.6-.74-3.21-1.46-4.84-2.12-1.22-.5-2.45-.96-3.69-1.39-2.04-.7-4.1-1.29-6.19-1.83-2.79-.71-5.63-1.32-8.57-1.94-1.87-.4-7.76-.64-9.69-1.07l-.02-3.12-.03-4.79-.02-3.53-.02-4.79-.02-2.94-.03-4.79-.02-3.53-.02-4.79v-1.71c.84-.39,1.7-.78,2.55-1.16,1.03-.46,5.76-1.49,6.77-1.94,1.27-.57,3.63-1.17,4.87-1.73,3.73-1.68,6.5-2.95,10.06-5,.1-.06.2-.12.31-.18,2.46-1.43,4.89-3,7.27-4.64,2.14-1.47,4.24-2.97,6.32-4.46l1.82-1.3c.66-.47,1.22-.22,1.43-.1.21.13.69.52.7,1.38l.04,7.94.1,17.91.2,37.3c0,.86-.48,1.36-.69,1.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.86,111.18c.55,1.02.04,2.36-1.09,2.62-.08.02-.15.03-.22.04-1.53.14-3.08.23-4.63.29-2.05.08-4.1.1-6.11.12h-1.54c-3.14.06-4.41-.81-5.43-3.68-.03-.07-.05-.14-.08-.21-.79-2.2-1.57-4.42-2.35-6.63-.64-1.79-1.26-3.59-1.88-5.36-.39-1.12-.78-2.22-1.17-3.33l-.22-.63-1.25-3.57c1.69-.05,3.38-.1,5.08-.16,3.4-.1,6.83-.2,10.29-.31l.94-.03.46.13c.3.94.59,1.86.88,2.78.12.38.23.75.35,1.12.56,1.76,1.14,3.56,1.77,5.33.4,1.11.81,2.22,1.26,3.32.1.23.2.46.3.68.69,1.45,1.6,2.77,2.49,4.05.44.63.86,1.23,1.24,1.84.16.26.32.52.47.79l.06.1c.1.17.24.42.39.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.65,90.47l-.46-.13h.41s.03.08.05.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.37,80.83c-.39.57-.98.93-1.67,1.01-.69.08-1.38-.15-1.89-.63l-.06-.05c-.82-.78-.98-2.03-.36-2.97,2.51-3.88,3.72-8.1,3.59-12.51-.13-4.47-1.54-8.55-4.18-12.13-.71-.95-.64-2.25.15-3.07l.07-.07c.48-.5,1.12-.76,1.81-.73.19,0,.38.04.56.09.46.13.87.4,1.18.79,5.69,7.17,7.8,19.87.82,30.28Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.94,
    width: 23.54,
    height: 23.54
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.94,
    y: 115.5,
    width: 23.54,
    height: 23.54
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 13.98,
    cy: 71.36,
    r: 13.98
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "19.77 17.8 35.89 33.71 35.89 108.01 19.86 124.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.46,
    y1: 70.06,
    x2: 49.13,
    y2: 70.06
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertismentGroup);
export default __webpack_public_path__ + "static/media/AdvertismentGroup.d00305e396f89c670bd619d5b71b5b2d.svg";
export { ForwardRef as ReactComponent };